/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Archive_Space_BodyInputs */

const en_lifecycle_archive_space_body = /** @type {(inputs: Lifecycle_Archive_Space_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The space and all its products become read-only and disappear from the sidebar, lists and search. You can unarchive it at any time.`)
};

const de_lifecycle_archive_space_body = /** @type {(inputs: Lifecycle_Archive_Space_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bereich und alle seine Produkte werden schreibgeschützt und verschwinden aus Seitenleiste, Listen und Suche. Du kannst ihn jederzeit aus dem Archiv holen.`)
};

/**
* | output |
* | --- |
* | "The space and all its products become read-only and disappear from the sidebar, lists and search. You can unarchive it at any time." |
*
* @param {Lifecycle_Archive_Space_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archive_space_body = /** @type {((inputs?: Lifecycle_Archive_Space_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archive_Space_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archive_space_body(inputs)
	return en_lifecycle_archive_space_body(inputs)
});